import { ref, Ref } from '@vue/composition-api';
import { AdgroupFormData, AD_GROUP_WEBSITE_TYPES, PixelAssetRelationStatus } from '@tt4b/ttam-enums';
import { getPixelListWithPagination } from '@tt4b/ttam-hooks';

type PixleItem = {
  id: string;
  name: string;
  pixelCode: string;
  pixelVersion: number;
  status: number;
  assetRelationStatus: PixelAssetRelationStatus;
  hasPcmConfig: boolean;
  availableQuota: number;
  isOnSite: boolean;
};

const loading = ref(false);
const oriPixelList = ref<PixleItem[]>([]);

export function usePixelList(opt: {
  promotionTargetType?: AdgroupFormData['promotionTargetType'];
  objectiveType?: AdgroupFormData['objectiveType'];
}) {
  function setPixelList(arr: PixleItem[]) {
    oriPixelList.value = arr;
  }

  function loadPixelList(parmas = {}) {
    loading.value = true;
    return getPixelListWithPagination({
      page: 1,
      promotion_website_type: AD_GROUP_WEBSITE_TYPES.offSite,
      promotion_target_type: opt.promotionTargetType,
      objective_type: opt.objectiveType,
      ...parmas,
    })
      .then(data => {
        setPixelList(data.pixelList ?? []);
      })
      .finally(() => {
        loading.value = false;
      });
  }

  return {
    loading,
    oriPixelList,
    loadPixelList,
  };
}
